
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


const dataList = [{
src:"",
name:"ABB CLMD低压电点容器电点容器",
money:"2000.00"
},{
src:"",
name:"ABB CLMD低压电点容器电点容器",
money:"2000.00"
},{
src:"",
name:"ABc CLMD低压电点容器电点容器",
money:"2000.00"
},{
src:"",
name:"ABB CLMD低压电点容器电点容器",
money:"1000.00"
}]

export default {
components: {
XHeader,
Tab,
TabItem
},
data () {
return {
abc: true,
editSkuInfo:{
listQuery: { dataList:[]}
},
tabIndex:0,//tab第几项
classifyList:[],
model:{pageSize:10},
name:{appTypeId:""},
images: require('../img/moreCloud.png'),
historyWord:[],
newHistoryWord:[],
changePage:false,
storage:{},
index:0,
loading: false,
finished: false

}
},
created(){

this. getHardware(this.name,0);
this.getTabList();
},

methods: {
switchTabItem(item,index) {
this.finished = false;
this.model.pageSize=10;
this. getHardware(item,index);
},
openDetail(goodsId){
window.location="/m/#/m/shop/hw/detail?goodsId="+goodsId
},
getOneSearch(){
this.getHistorySearch();
this.changePage=true;
},
getHardware(item,index){
if(item!=null && item !=undefined){
this.model["types"]=item.appTypeId;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/hardware/getList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.editSkuInfo.listQuery.dataList = res.body.rows;
}
},function(res){
console.log(res.status);
});
}
},
getTabList(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/hardware/getappTypes',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.classifyList = res.body.lists;
this.classifyList.push("")
}
},function(res){
console.log(res.status);
});
},
getHistorySearch(){
this.newHistoryWord=[];
var that = this
this.storage=window.localStorage;
var tmpe=[];
for(var i=1;i<11;i++){
if( this.storage.getItem('search_'+i)!= null){
this.newHistoryWord.push({"historyWord":this.storage.getItem('search_'+i)});
this.abc = false
this.$nextTick(function () {
that.abc = true
})
}else{
return;
}
}


},
goSearch(){
if(this.model.goodsTitle!=null && this.model.goodsTitle.trim()!=""){

if(localStorage.getItem("index")==null){
localStorage.setItem("index",1);
localStorage.setItem("search_1",this.model.goodsTitle);
}else{
var index=localStorage.getItem("index");

if(index==10){
index=1
}else{
index++;
}
var searchMode="";
for(var i=1;i<=localStorage.getItem("index");i++){
if(localStorage.getItem("search_"+i)==this.model.goodsTitle){
break;
}
if(i==(localStorage.getItem("index"))){
localStorage.setItem("index",index);
localStorage.setItem("search_"+index,this.model.goodsTitle);
}
}

}
this.index++;
this.storage.setItem(this.index, this.model.goodsTitle);
}
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/hardware/getList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.editSkuInfo.listQuery.dataList = res.body.rows;
this.changePage=false;
}
},function(res){
console.log(res.status);
});

},
goBack(){
this.$router.go(0);
},
getSearch(item){
this.model.goodsTitle=item.historyWord;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/hardware/getList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.editSkuInfo.listQuery.dataList = res.body.rows;
this.changePage=false;
}
},function(res){
console.log(res.status);
});
},
clearHistory(){
localStorage.clear();
alert("删除历史数据成功");
this.$router.go(0);
},
onLoad() {

setTimeout(() => {
this.model.pageSize=this.model.pageSize+10;
this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/hardware/getList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.editSkuInfo.listQuery.dataList = res.body.rows;
console.log( res.body.dbTypes+111111111111);

this.loading = false;

if (this.editSkuInfo.listQuery.dataList.length >= res.body.total) {
this.finished = true;
}
}
},function(res){
console.log(res.status);
});
}, 500);
},
}
}



// WEBPACK FOOTER //
// ./src/views/hw/hwIndex.vue